import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";

const SaveIcon: FunctionComponent = () => <MaterialUiIcons.Save />;

export default SaveIcon;
